import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const Add_CategoryList = () => {
  const [formData, setFormData] = useState({ test_category: "" });
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const response = await fetch(`${API_BASE_URL}api/addTestCategories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_token")}`, // Include JWT token if required
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to add category");
      }

      const data = await response.json();
      console.log("Success:", data);

      setShowSnackbar(true);
      setFormData({ test_category: "" }); // Reset input after success

      setTimeout(() => {
        setShowSnackbar(false);
      }, 3000);
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Failed to add category. Please try again.");
    }
  };

  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page">
        <div className="position-relative">
          <Navbar />
        </div>
        <div className="content-inner container-fluid pb-0" id="page_layout">
          {showSnackbar && (
            <div className="snackbar">
              <p>Test Category added Successfully!</p>
            </div>
          )}

          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">New Category Information</h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="new-user-info">
                      <div className="row">
                        <div className="form-group col-md-6">
                          <label htmlFor="test_category">Test Category Name :</label>
                          <input
                            type="text"
                            className="form-control form-control-sm my-2"
                            id="test_category"
                            name="test_category"
                            value={formData.test_category}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-danger-subtle"
                          onClick={() => window.history.back()}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-sm btn-primary-subtle">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Add_CategoryList;
